import { getQueryParams, getSearchListQuery } from "../utils/utils";
import { get, remove, put, post } from "./http.service";

const propertyService = {
  // getPropertyCodes: ({ id, type }) => get(`property/codes/${id || ""}?${type ? `propertyType=${type}` : ""}`),
  getPropertyCodes: ({ id, includeDpm, ...query }) =>
    get(
      `property/codes/${id || ""}${getSearchListQuery(query)}${
        includeDpm === undefined ? "" : `&includeDpm=${includeDpm}`
      }`,
    ),
  verifyPropertyCode: id => get(`property/codes/verify/${id}`),
  getPropertyMedia: ({ id, propertyType }) => get(`bynder/${id}?type=${propertyType}`),
  searchDashboardProperties: (query, getPropertyType) =>
    get(`property/${getPropertyType}`, { params: getQueryParams(query) }),
  searchProperties: query => get(`property/search`, { params: getQueryParams(query) }),
  suggestions: query => get(`property/suggestion${getSearchListQuery(query)}`),
  removeProperty: id => remove(`property/${id}`),
  convertProperty: body => put(`property/convertProperty`, body),
  republishMultipleProperties: body => post(`property/republishMultipleProperties`, body),
  searchRFMChanges: query => get(`property/unpublishedUnits${getSearchListQuery(query)}`),
  rfmChangesSuggestions: keyword => get(`property/unpublishedUnits/suggestion?keyword=${keyword}`),
};
export default propertyService;
